import AIAnalysisCriteriaModal from "./AIAnalysisCriteriaModal";
export default AIAnalysisCriteriaModal;
